/* eslint-disable no-console */
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

interface OrgState {
    currentOrgId: string | null
    currentUserLevel: number | null
    setCurrentOrg: (id: string, level: number) => void
}

export const useOrgStore = create<OrgState>()(
    subscribeWithSelector((set, get) => {
        let storedOrgId: string | null = null

        try {
            const rawStoredOrgId = localStorage.getItem('currentOrgId')
            storedOrgId = rawStoredOrgId ? JSON.parse(rawStoredOrgId) : null
        } catch (error) {
            console.error("Error parsing 'currentOrgId':", error)
            storedOrgId = null
        }

        // Cross-tab synchronization
        const syncState = (event: StorageEvent) => {
            if (event.key === 'currentOrgId') {
                const newOrgId = event.newValue ? JSON.parse(event.newValue) : null
                if (newOrgId !== get().currentOrgId) {
                    set({ currentOrgId: newOrgId })
                }
            }
        }

        if (typeof window !== 'undefined') {
            window.addEventListener('storage', syncState)
        }

        return {
            currentOrgId: storedOrgId,
            currentUserLevel: null,
            setCurrentOrg: (id, level) => {
                // Force immediate state update
                set({ currentOrgId: id, currentUserLevel: level })

                // Update localStorage and broadcast
                localStorage.setItem('currentOrgId', JSON.stringify(id))
                window.dispatchEvent(new StorageEvent('storage', {
                    key: 'currentOrgId',
                    newValue: JSON.stringify(id)
                }))
            },
        }
    })
)